import React from 'react'

const Create = () => {
  return (
    <div>
      Create Products
    </div>
  )
}

export default Create
